import React from "react";

export default function Privacy() {
  return (
    <>
      <section className="mt-32">
        <div className="container mx-auto">
          <div className="text-center">
            <h1 className="text-4xl uppercase" style={{ color: "#140342", fontSize: "30px" }}>Privacy Notice</h1>
            <p className="mt-[5px] text-lg" style={{ color: "#4F547B", fontSize: "17px" }}>Last updated 08/10/2024</p>
          </div>
        </div>
      </section>
      <section className="pt-12 pb-20 text-justify p-4">
        <div className="container mx-auto">
          <div className="flex justify-center">
            <div className="max-w-6xl">
              <h3 className=" text-3xl font-bold" style={{ color: "#140342", fontSize: "33.75px" }}>Privacy Policy</h3>
              <p className="mt-[7.5px] leading-relaxed" style={{ color: "#4F547B", fontSize: "15px" }}>
                This Privacy Notice for Neet Support("we," "us," or "our"),
                describes how and why we might access, collect, store, use,
                and/or share ("process") your personal information when you use
                our services ("Services"), including when you: Questions or
                concerns? Reading this Privacy Notice will help you understand
                your privacy rights and choices. We are responsible for making
                decisions about how your personal information is processed. If
                you do not agree with our policies and practices, please do not
                use our Services.
              </p>
              <h3 className="text-2xl mt-[30px] font-bold" style={{ color: "#140342", fontSize: "22.5px" }}>
                SUMMARY OF KEY POINTS
              </h3>
              <p className="mt-[7.5px] text-justify italic" style={{ color: "#4F547B", fontSize: "15px" }}>
                This summary provides key points from our Privacy Notice, but
                you can find out more details about any of these topics by
                clicking the link following each key point or by using our table
                of contents below to find the section you are looking for.
              </p>
              <p class="mt-10 text-[15px] text-[#4F547B]" >
                <span className="text-black font-bold text-lg" style={{ color: "#4F547B", fontSize: "16.875px" }}>
                  What personal information do we process?
                </span>{" "}
                <br></br>
                When you visit, use, or navigate our Services, we may process
                personal information depending on how you interact with us and
                the Services, the choices you make, and the products and
                features you use. Learn more about personal information you
                disclose to us.
              </p>

              <p class="mt-10 text-[15px] text-[#4F547B]">
                <span className="text-black font-bold text-lg" style={{ fontSize: "16.875px" }}>
                  Do we process any sensitive personal information?
                </span>{" "}
                <br></br>
                Some of the information may be considered "special" or
                "sensitive" in certain jurisdictions, for example your racial or
                ethnic origins, sexual orientation, and religious beliefs. We do
                not process sensitive personal information.
              </p>

              <p class="mt-10 text-[15px] text-[#4F547B]">
                <span className="text-black font-bold text-lg" style={{ fontSize: "16.875px" }}>
                  {" "}
                  Do we collect any information from third parties?{" "}
                </span>{" "}
                <br></br>
                We may collect information from public databases, marketing
                partners, social media platforms, and other outside sources.
                Learn more about information collected from other sources.
              </p>

              <p class="mt-10 text-[15px] text-[#4F547B]">
                <span className="text-black font-bold text-lg" style={{ fontSize: "16.875px" }}>
                  {" "}
                  How do we process your information?{" "}
                </span>{" "}
                <br></br>
                We process your information to provide, improve, and administer
                our Services, communicate with you, for security and fraud
                prevention, and to comply with law. We may also process your
                information for other purposes with your consent. We process
                your information only when we have a valid legal reason to do
                so. Learn more about how we process your information.
              </p>

              <p class="mt-10 text-[15px] text-[#4F547B]">
                <span className="text-black font-bold text-lg" style={{ fontSize: "16.875px" }}>
                  {" "}
                  In what situations and with which parties do we share personal
                  information?{" "}
                </span>
                <br></br>
                We may share information in specific situations and with
                specific third parties. Learn more about when and with whom we
                share your personal information.
              </p>

              <p class="mt-10 text-[15px] text-[#4F547B]">
                <span className="text-black font-bold text-lg" style={{ fontSize: "16.875px" }}>
                  {" "}
                  What are your rights?{" "}
                </span>
                <br></br>
                Depending on where you are located geographically, the
                applicable privacy law may mean you have certain rights
                regarding your personal information. Learn more about your
                privacy rights.
              </p>

              <p class="mt-10 text-[15px] text-[#4F547B]">
                <span className="text-black font-bold text-lg" style={{ fontSize: "16.875px" }}>
                  {" "}
                  How do you exercise your rights?{" "}
                </span>
                <br></br>
                The easiest way to exercise your rights is by submitting a data
                subject access request, or by contacting us. We will consider
                and act upon any request in accordance with applicable data
                protection laws.
              </p>

              <p class="mt-10 text-[15px] text-[#4F547B]">
                <span className="text-black font-bold text-lg" style={{ fontSize: "16.875px" }}>
                  {" "}
                  Want to learn more about what we do with any information we
                  collect?
                </span>{" "}
                <br></br>
                Review the Privacy Notice in full.
              </p>

              <div className="col-xl-8 col-lg-9 col-md-11">
                <h2 className="mt-[22.5px] sm:text-4xl text-3xl font-bold pb-[22.5px]" style={{ color: "#140342", fontSize: "33.75px" }}>
                  TABLE OF CONTENTS
                </h2>
                <ol className="ml-6 text-blue-500" style={{ fontSize: "15px" }}>
                  <li>1. WHAT INFORMATION DO WE COLLECT?</li>
                  <li>2. HOW DO WE PROCESS YOUR INFORMATION?</li>
                  <li>
                    3. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?
                  </li>
                  <li>4. DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?</li>
                  <li>5. HOW DO WE HANDLE YOUR SOCIAL LOGINS?</li>
                  <li>6. IS YOUR INFORMATION TRANSFERRED INTERNATIONALLY?</li>
                  <li>7. HOW LONG DO WE KEEP YOUR INFORMATION?</li>
                  <li>8. DO WE COLLECT INFORMATION FROM MINORS?</li>
                  <li>9. WHAT ARE YOUR PRIVACY RIGHTS?</li>
                  <li>10. CONTROLS FOR DO-NOT-TRACK FEATURES</li>
                  <li>11. DO WE MAKE UPDATES TO THIS NOTICE?</li>
                  <li>12. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</li>
                  <li>
                    13. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE
                    COLLECT FROM YOU?
                  </li>
                </ol>
                <h3 className="text-2xl font-bold mt-[30px]" style={{ color: "#140342", fontSize: "22.5px" }}>
                  1. WHAT INFORMATION DO WE COLLECT?
                </h3>
                <p className="mt-[7.5px] text-xl  text-black font-bold" style={{ fontSize: "18.75px" }}>
                  Personal information you disclose to us
                </p>
                <p className="italic mt-[10px]" style={{ fontSize: "15px", color: "#4F547B" }}>
                  In Short: We collect personal information that you provide to
                  us.
                </p>
                <p className="mt-[10px]" style={{ fontSize: "15px", color: "#4F547B" }}>
                  We collect personal information that you voluntarily provide
                  to us when you register on the Services, express an interest
                  in obtaining information about us or our products and
                  Services, when you participate in activities on the Services,
                  or otherwise when you contact us.
                </p>

                <p className="italic mt-[20px]" style={{ fontSize: "15px", color: "#4F547B" }}>
                  Sensitive Information. We do not process sensitive
                  information.
                </p>
                <p className="mt-5" style={{ fontSize: "15px", color: "#4F547B" }}>
                  All personal information that you provide to us must be true,
                  complete, and accurate, and you must notify us of any changes
                  to such personal information.
                </p>
                <p className="mt-[7.5px] text-xl  text-black font-bold" style={{ fontSize: "18.75px" }}>
                  Information automatic collected
                </p>
                <p className="mt-[7.5px] italic" style={{ fontSize: "15px", color: "#4F547B" }}>
                  In Short: Some information — such as your Internet Protocol
                  (IP) address and/or browser and device characteristics — is
                  collected automatically when you visit our Services.
                </p>
                <p className="mt-[30px]" style={{ fontSize: "15px", color: "#4F547B" }}>
                  We automatically collect certain information when you visit,
                  use, or navigate the Services. This information does not
                  reveal your specific identity (like your name or contact
                  information) but may include device and usage information,
                  such as your IP address, browser and device characteristics,
                  operating system, language preferences, referring URLs, device
                  name, country, location, information about how and when you
                  use our Services, and other technical information. This
                  information is primarily needed to maintain the security and
                  operation of our Services, and for our internal analytics and
                  reporting purposes. Like many businesses, we also collect
                  information through cookies and similar technologies.
                </p>

                <h3 className="sm:text-2xl text-xl  font-bold mt-[22.5px]" style={{ color: "#140342", fontSize: "22.5px" }}>
                  2. How Do We Process Your Information?
                </h3>
                <p className="mt-[30px] italic" style={{ fontSize: "15px", color: "#4F547B" }}>
                  In Short: We process your information to provide, improve, and
                  administer our Services, communicate with you, for security
                  and fraud prevention, and to comply with law. We may also
                  process your information for other purposes with your consent
                </p>
                <p className="mt-[30px]" style={{ fontSize: "15px", color: "#4F547B" }}>
                  We process your personal information for a variety of reasons,
                  depending on how you interact with our Services, including:
                </p>

                <h3 className="sm:text-2xl text-xl font-bold mt-[22.5px]" style={{ color: "#140342", fontSize: "22.5px" }}>
                  3. When and With Whom Do We Share Your Personal Information?
                </h3>
                <p className="mt-[30px] italic" style={{ fontSize: "15px", color: "#4F547B" }}>
                  In Short: We may share information in specific situations
                  described in this section and/or with the following third
                  parties.
                </p>
                <p className="mt-[30px]" style={{ fontSize: "15px", color: "#4F547B" }}>
                  We may need to share your personal information in the
                  following situations: <p></p>
                  <span className="text-black font-bold">
                    Business Transfers.
                  </span>{" "}
                  We may share or transfer your information in connection with,
                  or during negotiations of, any merger, sale of company assets,
                  financing, or acquisition of all or a portion of our business
                  to another company.<p></p>{" "}
                  <span className="text-black font-bold">Affiliates.</span> We
                  may share your information with our affiliates, in which case
                  we will require those affiliates to honor this Privacy Notice.
                  Affiliates include our parent company and any subsidiaries,
                  joint venture partners, or other companies that we control or
                  that are under common control with us.<p></p>{" "}
                  <span className="text-black font-bold">
                    Business Partners.
                  </span>{" "}
                  We may share your information with our business partners to
                  offer you certain products, services, or promotions.
                </p>

                <h3 className="sm:text-2xl text-xl font-bold mt-[30px]" style={{ color: "#140342", fontSize: "22.5px" }}>
                  4. Do We Use Cookies and Other Tracking Technologies?
                </h3>
                <p className="mt-[30px] italic" style={{ fontSize: "15px", color: "#4F547B" }}>
                  In Short: We may use cookies and other tracking technologies
                  to collect and store your information.
                </p>
                <p className="mt-[20px]" style={{ fontSize: "15px", color: "#4F547B" }}>
                  {" "}
                  We may use cookies and similar tracking technologies (like web
                  beacons and pixels) to gather information when you interact
                  with our Services. Some online tracking technologies help us
                  maintain the security of our Services, prevent crashes, fix
                  bugs, save your preferences, and assist with basic site
                  functions. <p></p>
                  We also permit third parties and service providers to use
                  online tracking technologies on our Services for analytics and
                  advertising, including to help manage and display
                  advertisements, to tailor advertisements to your interests, or
                  to send abandoned shopping cart reminders (depending on your
                  communication preferences). The third parties and service
                  providers use their technology to provide advertising about
                  products and services tailored to your interests which may
                  appear either on our Services or on other websites.<p></p>{" "}
                  Specific information about how we use such technologies and
                  how you can refuse certain cookies is set out in our Cookie
                  Notice.
                </p>

                <h3 className="sm:text-2xl text-xl font-bold mt-[22.5px]" style={{ color: "#140342", fontSize: "22.5px" }}>
                  5. How Do We Handle Your Social Logins?
                </h3>
                <p className="mt-[30px] italic" style={{ fontSize: "15px", color: "#4F547B" }}>
                  In Short: If you choose to register or log in to our Services
                  using a social media account, we may have access to certain
                  information about you.
                </p>
                <p className="mt-[22.5px]" style={{ fontSize: "15px", color: "#4F547B" }}>
                  {" "}
                  Our Services offer you the ability to register and log in
                  using your third-party social media account details (like your
                  Facebook or X logins). Where you choose to do this, we will
                  receive certain profile information about you from your social
                  media provider. The profile information we receive may vary
                  depending on the social media provider concerned, but will
                  often include your name, email address, friends list, and
                  profile picture, as well as other information you choose to
                  make public on such a social media platform.<p></p>
                  We will use the information we receive only for the purposes
                  that are described in this Privacy Notice or that are
                  otherwise made clear to you on the relevant Services. Please
                  note that we do not control, and are not responsible for,
                  other uses of your personal information by your third-party
                  social media provider. We recommend that you review their
                  privacy notice to understand how they collect, use, and share
                  your personal information, and how you can set your privacy
                  preferences on their sites and apps.
                </p>

                <h3 className="sm:text-2xl text-xl font-bold mt-[22.5px]" style={{ color: "#140342", fontSize: "22.5px" }}>
                  6. Is Your Information Transferred Internationally?
                </h3>
                <p className="mt-[30px] italic" style={{ fontSize: "15px", color: "#4F547B" }}>
                  In Short: We may transfer, store, and process your information
                  in countries other than your own.
                </p>
                <p className="mt-[20px]" style={{ fontSize: "15px", color: "#4F547B" }}>
                  {" "}
                  Our servers are located in. If you are accessing our Services
                  from outside, please be aware that your information may be
                  transferred to, stored by, and processed by us in our
                  facilities and in the facilities of the third parties with
                  whom we may share your personal information (see "WHEN AND
                  WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?" above), in
                  and other countries. If you are a resident in the European
                  Economic Area (EEA), United Kingdom (UK), or Switzerland, then
                  these countries may not necessarily have data protection laws
                  or other similar laws as comprehensive as those in your
                  country. However, we will take all necessary measures to
                  protect your personal information in accordance with this
                  Privacy Notice and applicable law.
                </p>
                <h3 className="sm:text-2xl text-xl font-bold mt-[22.5px]" style={{ color: "#140342", fontSize: "22.5px" }}>
                  7. How Long Do We Keep Your Information?
                </h3>
                <p className="mt-[30px] italic" style={{ fontSize: "15px", color: "#4F547B" }}>
                  In Short: We keep your information for as long as necessary to
                  fulfill the purposes outlined in this Privacy Notice unless
                  otherwise required by law.
                </p>
                <p className="mt-[20px]" style={{ fontSize: "15px", color: "#4F547B" }}>
                  {" "}
                  We will only keep your personal information for as long as it
                  is necessary for the purposes set out in this Privacy Notice,
                  unless a longer retention period is required or permitted by
                  law (such as tax, accounting, or other legal requirements).
                  <p></p>
                  When we have no ongoing legitimate business need to process
                  your personal information, we will either delete or anonymize
                  such information, or, if this is not possible (for example,
                  because your personal information has been stored in backup
                  archives), then we will securely store your personal
                  information and isolate it from any further processing until
                  deletion is possible.
                </p>

                <h3 className="sm:text-2xl text-xl font-bold mt-[30px]" style={{ color: "#140342", fontSize: "22.5px" }}>
                  8. Do We Collect information From Minors?
                </h3>
                <p className="mt-[30px] italic" style={{ fontSize: "15px", color: "#4F547B" }}>
                  In Short: We do not knowingly collect data from or market to
                  children under 18 years of age
                </p>
                <p className="mt-[20px]" style={{ fontSize: "15px", color: "#4F547B" }}>
                  {" "}
                  We do not knowingly collect, solicit data from, or market to
                  children under 18 years of age, nor do we knowingly sell such
                  personal information. By using the Services, you represent
                  that you are at least 18 or that you are the parent or
                  guardian of such a minor and consent to such minor dependent’s
                  use of the Services. If we learn that personal information
                  from users less than 18 years of age has been collected, we
                  will deactivate the account and take reasonable measures to
                  promptly delete such data from our records. If you become
                  aware of any data we may have collected from children under
                  age 18, please contact us at support@neetsupport.com.
                </p>

                <h3 className="sm:text-2xl text-xl font-bold mt-[30px]" style={{ color: "#140342", fontSize: "22.5px" }}>
                  9. What Are Your Privacy Rights?
                </h3>
                <p className="mt-[30px] italic" style={{ fontSize: "15px", color: "#4F547B" }}>
                  In Short: You may review, change, or terminate your account at
                  any time, depending on your country, province, or state of
                  residence.
                </p>
                <p className="mt-[20px]" style={{ fontSize: "15px", color: "#4F547B" }}>
                  {" "}
                  Withdrawing your consent: If we are relying on your consent to
                  process your personal information, which may be express and/or
                  implied consent depending on the applicable law, you have the
                  right to withdraw your consent at any time. You can withdraw
                  your consent at any time by contacting us by using the contact
                  details provided in the section "HOW CAN YOU CONTACT US ABOUT
                  THIS NOTICE?" below.<p></p>
                  However, please note that this will not affect the lawfulness
                  of the processing before its withdrawal nor, when applicable
                  law allows, will it affect the processing of your personal
                  information conducted in reliance on lawful processing grounds
                  other than consent.
                </p>
                <h3 className="text-2xl font-bold mt-[30px]" style={{ color: "#140342", fontSize: "22.5px" }}>
                  Account Information
                </h3>
                <p className="mt-[10px]" style={{ fontSize: "15px", color: "#4F547B" }}>
                  If you would at any time like to review or change the
                  information in your account or terminate your account, you
                  can: Upon your request to terminate your account, we will
                  deactivate or delete your account and information from our
                  active databases. However, we may retain some information in
                  our files to prevent fraud, troubleshoot problems, assist with
                  any investigations, enforce our legal terms and/or comply with
                  applicable legal requirements.
                </p>

                <h3 className="sm:text-2xl text-xl font-bold mt-[30px]" style={{ color: "#140342", fontSize: "22.5px" }}>
                  10. Controls For Do-Not-Track Features
                </h3>

                <p className="mt-[20px]" style={{ fontSize: "15px", color: "#4F547B" }}>
                  {" "}
                  Most web browsers and some mobile operating systems and mobile
                  applications include a Do-Not-Track ("DNT") feature or setting
                  you can activate to signal your privacy preference not to have
                  data about your online browsing activities monitored and
                  collected. At this stage, no uniform technology standard for
                  recognizing and implementing DNT signals has been finalized.
                  As such, we do not currently respond to DNT browser signals or
                  any other mechanism that automatically communicates your
                  choice not to be tracked online. If a standard for online
                  tracking is adopted that we must follow in the future, we will
                  inform you about that practice in a revised version of this
                  Privacy Notice.
                </p>

                <h3 className="sm:text-2xl text-xl font-bold mt-[30px]" style={{ color: "#140342", fontSize: "22.5px" }}>
                  11. Do We Make Updates To This Notice?
                </h3>
                <p className="mt-[30px] italic" style={{ fontSize: "15px", color: "#4F547B" }}>
                  In Short: Yes, we will update this notice as necessary to stay
                  compliant with relevant laws.
                </p>
                <p className="mt-[20px]" style={{ fontSize: "15px", color: "#4F547B" }}>
                  {" "}
                  We may update this Privacy Notice from time to time. The
                  updated version will be indicated by an updated "Revised" date
                  at the top of this Privacy Notice. If we make material changes
                  to this Privacy Notice, we may notify you either by
                  prominently posting a notice of such changes or by directly
                  sending you a notification. We encourage you to review this
                  Privacy Notice frequently to be informed of how we are
                  protecting your information.
                </p>

                <h3 className="sm:text-2xl text-xl font-bold mt-[30px]" style={{ color: "#140342", fontSize: "22.5px" }}>
                  12. How Can You Contact Us About This Notice?
                </h3>

                <p className="mt-[20px]" style={{ fontSize: "15px", color: "#4F547B" }}>
                  {" "}
                  If you have questions or comments about this notice, you may
                  contact us by post at:<br></br>
                  Plot No. 21 & 21A, Sector 142, <br></br>
                  Noida, Uttar Pradesh <br></br>
                  201304
                </p>

                <h3 className="sm:text-2xl text-xl font-bold mt-[30px]" style={{ color: "#140342", fontSize: "22.5px" }}>
                  13. How Can You Review, Update, Or Delete The Data We Collect
                  From You?
                </h3>

                <p className="mt-[20px]" style={{ fontSize: "15px", color: "#4F547B" }}>
                  Based on the applicable laws of your country, you may have the
                  right to request access to the personal information we collect
                  from you, details about how we have processed it, correct
                  inaccuracies, or delete your personal information. You may
                  also have the right to withdraw your consent to our processing
                  of your personal information. These rights may be limited in
                  some circumstances by applicable law. To request to review,
                  update, or delete your personal information, please fill out
                  and submit a data subject access request.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
